// export const URL = window.location.host; ReferenceError: window is not defined;

import { ReceiptType } from '../../types/ReceiptInput.types';

export const URL = typeof window !== 'undefined' ? window.location.host : '';

export enum SERVICESTYPE {
  MonthlyService = 'MonthlyService',
  SingleService = 'SingleService',
  YearlyService = 'YearlyService',
}

export const MONTHS = [
  { id: 1, title: 'Januar' },
  { id: 2, title: 'Februar' },
  { id: 3, title: 'März' },
  { id: 4, title: 'April' },
  { id: 5, title: 'Mai' },
  { id: 6, title: 'Juni' },
  { id: 7, title: 'Juli' },
  { id: 8, title: 'August' },
  { id: 9, title: 'September' },
  { id: 10, title: 'Oktober' },
  { id: 11, title: 'November' },
  { id: 12, title: 'Dezember' },
];
export const CONTRACTTYPSLIST: { id: number; title: string; value: ReceiptType }[] = [
  { id: 1, title: 'Belastung', value: 'IncomeReceipt' },
  { id: 2, title: 'Gutschrift', value: 'ExpenseReceipt' },
];

export const DEFAULTALERTOBJECT = {
  typeMessage: '',
  alertMessage: '',
  isAlertMessage: false,
};

export const DEFAULTTABLEPAGESIZE = {
  pageSize: 15,
};

export const AGENT_ROLES = {
  BANKER: 'Banker',
  ADMIN: 'Admin',
} as const;

export type AgentRole = (typeof AGENT_ROLES)[keyof typeof AGENT_ROLES];

export const AGENT_ROLES_OPTIONS = [{ value: AGENT_ROLES.BANKER, label: 'Punkteverwalter' }];
